type ConvertToSku = (sourceText: string) => string

export const convertToSku: ConvertToSku = (sourceText) => {
  return sourceText.toUpperCase().replace(/\s+/g, '-').replace(/_/g, '-')
}
